import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { appliances } from '../data/mockData';

const Maintenance = () => {
  const [servicing, setServicing] = useState(null);

  const handleService = (id) => {
    setServicing(id);
    setTimeout(() => setServicing(null), 2000); // Simulate network request
  };

  return (
    <div className="p-6 h-full overflow-y-auto scrollbar-hide pb-24 md:pb-6">
      <header className="mb-6">
        <h1 className="text-2xl font-bold text-slate-100">Hardware Diagnostics</h1>
        <p className="text-sm text-slate-400">Appliance health & inventory tracking</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {appliances.map((app, i) => (
          <motion.div key={app.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}
            className={`glass-panel rounded-2xl p-5 relative overflow-hidden ${app.status === 'Warning' ? 'border-amber-500/30' : ''}`}>
            
            <div className="flex justify-between items-start mb-6">
              <div className="flex items-center gap-3">
                <div className={`p-3 rounded-xl ${app.status === 'Warning' ? 'bg-amber-500/10 text-amber-400' : 'bg-teal-500/10 text-teal-400'}`}>
                   <SafeIcon icon={app.name.includes('Water') ? 'FiDroplet' : app.name.includes('HVAC') ? 'FiWind' : 'FiCpu'} className="w-6 h-6" />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-200">{app.name}</h3>
                  <span className={`text-xs font-mono px-2 py-0.5 rounded-full border ${app.status === 'Warning' ? 'border-amber-500/50 text-amber-400' : 'border-teal-500/50 text-teal-400'}`}>
                    {app.status.toUpperCase()}
                  </span>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <div className="flex justify-between text-sm mb-1">
                  <span className="text-slate-400">System Integrity</span>
                  <span className="font-mono text-slate-200">{app.health}%</span>
                </div>
                <div className="w-full h-2 bg-slate-800 rounded-full overflow-hidden">
                  <div className={`h-full rounded-full ${app.health < 50 ? 'bg-amber-400' : 'bg-teal-400'}`} style={{ width: `${app.health}%` }} />
                </div>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-slate-700/50">
                <div className="text-sm">
                  <p className="text-slate-500">Next Maintenance</p>
                  <p className={`font-medium ${app.nextService === 'Overdue' ? 'text-amber-400' : 'text-slate-300'}`}>{app.nextService}</p>
                </div>
                
                <button 
                  onClick={() => handleService(app.id)}
                  disabled={servicing === app.id}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2
                    ${servicing === app.id ? 'bg-slate-700 text-slate-400 cursor-not-allowed' : 
                      app.status === 'Warning' ? 'bg-amber-500 hover:bg-amber-600 text-slate-900' : 'bg-slate-800 hover:bg-slate-700 text-slate-300 border border-slate-700'}`}>
                  {servicing === app.id ? (
                    <><SafeIcon icon="FiLoader" className="animate-spin" /> Processing</>
                  ) : (
                    <><SafeIcon icon="FiTool" /> {app.status === 'Warning' ? 'Schedule Repair' : 'Log Maintenance'}</>
                  )}
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Maintenance;